import { RollbackOutlined, SaveOutlined } from '@ant-design/icons'
import { Button, Form, Input, Spin } from 'antd'
import { FormInstance } from 'antd/lib/form'
import React, { RefObject } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirebase, withFirestore } from 'react-redux-firebase'
import { withHandlers } from 'recompose'
import { compose } from 'redux'

import { withRouter } from 'react-router-dom'
import { SHOW_NOTIFICATION } from '../../constants/ActionTypes'
import { ERROR, SUCCESS } from '../../constants/notifications'
import {
  findInOrdered,
  fsCollections,
  makeInBatchWithFirebase,
  withoutUndefined,
} from '../../helpers/firestore'
import { CountrySelect } from '../countries'
import authorize from '../higher-order/authorize'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
}

class TeamForm extends React.Component<any, any> {
  formRef: RefObject<FormInstance<any>> = React.createRef()

  handleSubmit = (values) => {
    const { onSubmit } = this.props
    onSubmit(withoutUndefined({ ...values, type: 'global' }))
  }

  handleFailure = ({ errorFields }) => {
    this.formRef?.current?.scrollToField(errorFields[0].name)
    /* TODO display somewhere */
    // tslint:disable-next-line:no-console
    console.log('Error during validation', errorFields)
  }

  render() {
    const { teamId, team, previousLocation, goToPreviousLocation } = this.props

    const form = (
      <Form
        ref={this.formRef}
        onFinish={this.handleSubmit}
        onFinishFailed={this.handleFailure}
        initialValues={team}>
        <Form.Item
          {...formItemLayout}
          label="Name"
          hasFeedback
          name="name"
          rules={[{ required: true, message: 'Please input name!' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          label="Short Name"
          hasFeedback
          name="short"
          rules={[{ required: true, message: 'Please input short name!' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          label="Nationality"
          hasFeedback
          name="nationality"
          rules={[{ required: true, message: 'Please select a country!' }]}>
          <CountrySelect showSelection />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button.Group>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Submit
            </Button>
            {previousLocation ? (
              <Button danger onClick={goToPreviousLocation} icon={<RollbackOutlined />}>
                Cancel
              </Button>
            ) : null}
          </Button.Group>
        </Form.Item>
      </Form>
    )

    return teamId && !isLoaded(team) ? <Spin>{form}</Spin> : form
  }
}

export default compose<FIXME>(
  authorize('admin'),
  withFirebase,
  withFirestore,
  withRouter,
  firestoreConnect<FIXME>(({ tenant }) => [{ collection: fsCollections.globalTeams(tenant) }]),
  connect(({ firestore }: FIXME, { tenant, teamId }: FIXME) => ({
    team: findInOrdered(firestore.ordered[fsCollections.globalTeams(tenant)], teamId),
  })),
  withHandlers<any, any>({
    goToPreviousLocation: ({ history, previousLocation }) => () => {
      if (previousLocation) {
        history.push(previousLocation)
      }
    },
    inBatchBound: makeInBatchWithFirebase,
  }),
  withHandlers({
    upsertSuccess: ({ dispatch, goToPreviousLocation }) => () => {
      dispatch({ type: SHOW_NOTIFICATION, message: 'Team saved', kind: SUCCESS })
      goToPreviousLocation()
    },
    upsertError: ({ dispatch }) => (err) => {
      // tslint:disable-next-line:no-console
      console.error('Failed to save team', err)
      dispatch({ type: SHOW_NOTIFICATION, message: 'Failed to save team', kind: ERROR })
    },
    upsertTeam: ({ inBatchBound, tenant, teamId }) => (team) =>
      inBatchBound((firestore, batch) => {
        const collection = firestore.collection(fsCollections.globalTeams(tenant))
        const teamReference = teamId ? collection.doc(teamId) : collection.doc()

        batch.set(teamReference, team)
      }),
  }),
  withHandlers({
    onSubmit: ({ upsertTeam, upsertError, upsertSuccess }) => (team) =>
      upsertTeam(team)
        .then((res) => upsertSuccess(res))
        .catch((err) => upsertError(err)),
  }),
)(TeamForm)



// WEBPACK FOOTER //
// ./src/components/teams/TeamForm.tsx